import { Avatar, Button, Image, Table } from "antd";
import { EyeOutlined, DownloadOutlined, FileOutlined, FilePdfOutlined } from '@ant-design/icons';
import { BaseComponent, IBaseProps, IBaseStates } from "../../components/infrastructure/baseComponent";
import { IAttachment } from "./interfaces";
import React from "react";
import { ColumnsType } from "antd/lib/table";

export interface IAttachmentViewerProps extends IBaseProps {
    attachments: IAttachment[];
    extraColumns?: () => any[];
}

export interface IAttachmentViewerStates extends IBaseStates {

}

export class AttachmentViewer extends BaseComponent<IAttachmentViewerProps, IAttachmentViewerStates>{
    constructor(props: IAttachmentViewerProps) {
        super(props)
        this.state = {
            isAuthorized: true,
            loading: true,
            windowSize: window.innerWidth <= 765 ? 1 : 2
        };
    }
    componentDidMount() {
        super.componentDidMount();
        this.setLoading(false);
    }
    virtualRender() {
        const columns: ColumnsType<IAttachment> = [{
            title: 'مستند',
            dataIndex: 'Path',
            key: 'Path',
            render: (_: any, record: IAttachment) => {
                if (!record.Path) {
                    return <></>;
                }

                const mask: React.ReactNode = (
                    <>
                        <Button style={{ backgroundColor: 'transparent', border: 'none' }} icon={<EyeOutlined />} size={"large"} title="نمایش" />
                        <a href={record.Path} download={record.Title}>
                            <Button style={{ backgroundColor: 'transparent', border: 'none' }} icon={<DownloadOutlined />} size={"large"} title="دانلود"
                                onClick={(e) => {
                                    e.stopPropagation();
                                }}
                            />
                        </a>
                    </>
                );
                const fileNameParts = record.Path.split('.');
                const fileExtension = fileNameParts[fileNameParts.length - 1];
                const isImage = ['png', 'jpg', 'jpeg', 'bmp'].indexOf(fileExtension) > -1;
                const isPdf = ['pdf'].indexOf(fileExtension) > -1;
                return (
                    <div>
                        {isImage
                            ? <Avatar src={<Image width={100} preview={{ mask, src: record.Path }} src={record.Path + '?x-oss-process=image/blur,r_3,s_2/quality,q_1/resize,m_mfit,h_100,w_100'} style={{ height: 100 }} />} size={100} />
                            :
                            <a href={record.Path} download={record.Title}>
                                <Avatar icon={isPdf ? <FilePdfOutlined style={{ verticalAlign: 'baseline', height: 100 }} /> : <FileOutlined style={{ verticalAlign: 'baseline', height: 100 }} />} size={100} />
                            </a>
                        }
                    </div>
                );
            },
        },
        //{
        //    title: 'نام فایل',
        //    dataIndex: 'Title',
        //    key: 'Title',
        //}
        {
            title: 'توضیحات',
            dataIndex: 'Description',
            key: 'Description',
        }];

        if (this.props.extraColumns)
            columns.push(...this.props.extraColumns());

        return (
            <div>
                <Table scroll={{ x: "max-content" }} rowKey={"RowGuid"} columns={columns} dataSource={this.props.attachments} bordered />
            </div>
        );
    }
}